import { AxiosError } from 'axios'
import { showToast } from '@/ui/kit/components/toast'

interface ErrorResponse {
  message: string
}

export const handleError = (
  error: unknown,
  option: {
    showMessage?: boolean
  } = {
    showMessage: true,
  },
): never => {
  if (error instanceof AxiosError && error.response && error.response.data) {
    const responseData = error?.response?.data as ErrorResponse
    option.showMessage &&
      showToast({
        title: responseData?.message,
        type: 'error',
      })
    throw responseData || error
  } else if (error instanceof Error && error.message) {
    option.showMessage &&
      showToast({
        title: error.message,
        type: 'error',
      })
    throw error
  } else {
    option.showMessage &&
      showToast({
        title: 'مشکلی رخ داده است!',
        type: 'error',
      })
    throw error
  }
}
